import { StyledTable } from './style';

const Table = StyledTable;
export default Table;
